var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-hashtag",
      class: { edit: _vm.isSelected },
      on: { click: _vm.finish },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c(
        "div",
        {
          staticClass: "sticker sticker-hashtag",
          class: `style${_vm.stickerInstance.data.styleVariant}`,
          on: { click: _vm.stickerInstance.nextStyleVariant },
        },
        [
          _c("div", { staticClass: "icon" }),
          _c("p", {
            ref: "hashtagInput",
            staticClass: "textarea",
            attrs: { contenteditable: _vm.isSelected },
            domProps: { innerHTML: _vm._s(_vm.stickerInstance.data.hashtag) },
            on: { input: _vm.handlerInput },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "hashtags hide-scrollbar",
          on: { wheel: _vm.handleHorizontalScroll },
        },
        _vm._l(_vm.hashtags, function (h) {
          return _c(
            "div",
            {
              staticClass: "hashtag",
              on: { click: () => _vm.selectHashtag(h.hashtag) },
            },
            [_c("p", [_vm._v("#" + _vm._s(h.hashtag))])]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }